import { captureMessage } from "@sentry/nextjs"

export const captureClientMessage = (
  message: string,
  captureContext?: Parameters<typeof captureMessage>[1],
): string => captureMessage(message, captureContext)
